import {Injectable} from '@angular/core';
import {WelcomeModalComponent} from "./welcome-modal.component";
import {ShippingService} from "../shipping/shipping.service";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {UsanaObject} from "../usana-object";
import {LoggerService} from "../common/logger.service";
import {ModalUtil} from "../modal/modal-util";

@Injectable({
    providedIn: 'root'
})
export class WelcomeModalService extends UsanaObject {

    bsModalRef: BsModalRef;

    constructor(
        loggerService: LoggerService,
        public modalService: BsModalService,
        public shippingService: ShippingService
    ) {
        super(loggerService);
    }

    open(customerType: string): BsModalRef {
        this.shippingService.getFirstTimeMessage(customerType).then((data: any) => {
            if (!!data && !ModalUtil.hasSeenWelcomeModal()) {
                ModalUtil.rememberWelcomeModalOpened();

                const initialState = {displayText: data};
                this.bsModalRef = this.modalService.show(WelcomeModalComponent, Object.assign({}, {initialState}));
            }
        }, (error: any) => this.log.error("error getFirstTimeMessage", error));
        return this.bsModalRef;
    }
}
